import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditStudentEnrollment from '../../components/studentEnrollments/FormAddEditStudentEnrollment';
const CreateStudentEnrollment = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditStudentEnrollment /></WrapperSection>);
export default CreateStudentEnrollment;
